const config = {
	wechat: {
		oauth: function() {
			const website_url = encodeURIComponent(window.location.href); // 需要回跳的链接
			// return `http://127.0.0.1:8088/api-dev/platform/wechat/auth/oauth?appid=wx594855dad80a932f&redirect_url=${website_url}`;
			return `https://loparex.mobi/api/platform/wechat/auth/oauth?appid=wx594855dad80a932f&redirect_url=${website_url}`;

			
		}
	}
};

export default config;